<template>
  <div class="post-status-cards">
    <div class="post-status-cluster">
      <div class="post-status-cluster__title">Fase</div>
      <div class="post-status-cluster__cards">
        <button type="button" class="post-status-card"
          :class="{ 'post-status-card--active': active === 'all' }" @click="$emit('select', 'all')"
          title="Todos os status do período">
          <i class="el-icon-menu post-status-card__icon"></i>
          <span class="post-status-card__info">
            <span class="post-status-card__count">{{ format(total) }}</span>
            <span class="post-status-card__label">Todas</span>
          </span>
        </button>
        <button v-for="segment in faseSegments" :key="segment.key" type="button" class="post-status-card"
          :class="{
            'post-status-card--active': active === segment.key,
            'post-status-card--dim': isDim(segment),
          }" @click="$emit('select', segment.key)"
          :title="`${segment.label} — clique para filtrar a tabela`">
          <i :class="segment.icon" class="post-status-card__icon" :style="{ color: segment.color }"></i>
          <span class="post-status-card__info">
            <span class="post-status-card__count">{{ format(segment.count) }}</span>
            <span class="post-status-card__label">{{ segment.label }}</span>
          </span>
        </button>
      </div>
    </div>
    <div class="post-status-cluster post-status-cluster--divided">
      <div class="post-status-cluster__title">Situação</div>
      <div class="post-status-cluster__cards">
        <button v-for="segment in situationSegments" :key="segment.key" type="button" class="post-status-card"
          :class="{
            'post-status-card--active': active === segment.key,
            'post-status-card--dim': isDim(segment),
          }" @click="$emit('select', segment.key)"
          :title="`${segment.label} — clique para filtrar a tabela`">
          <i :class="segment.icon" class="post-status-card__icon" :style="{ color: segment.color }"></i>
          <span class="post-status-card__info">
            <span class="post-status-card__count">{{ format(segment.count) }}</span>
            <span class="post-status-card__label">{{ segment.label }}</span>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PostStatusDistribution",
  props: {
    segments: { type: Array, default: () => [] },
    total: { type: Number, default: 0 },
    active: { type: String, default: "all" },
    selected: { type: Array, default: () => [] },
  },
  computed: {
    faseSegments() {
      return this.segments.filter((segment) => segment.cluster === "fase");
    },
    situationSegments() {
      return this.segments.filter((segment) => segment.cluster !== "fase");
    },
    filterActive() {
      const universe = new Set();
      this.segments.forEach((segment) => {
        (segment.statuses || []).forEach((status) => universe.add(String(status)));
      });
      return this.selected.length > 0 && this.selected.length < universe.size;
    },
  },
  methods: {
    isDim(segment) {
      if (!this.filterActive) return false;
      return !(segment.statuses || []).some((status) => this.selected.includes(String(status)));
    },
    format(value) {
      return (+value || 0).toLocaleString("pt-BR");
    },
  },
};
</script>

<style scoped>
.post-status-cards {
  display: flex;
  flex-wrap: wrap;
}

.post-status-cluster--divided {
  border-left: 1px solid #ebeef5;
  padding-left: 18px;
  margin-left: 6px;
}

.post-status-cluster__title {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #909399;
  margin-bottom: 6px;
}

.post-status-cluster__cards {
  display: flex;
  flex-wrap: wrap;
}

.post-status-card {
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 10px 16px;
  margin: 0 8px 8px 0;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease, opacity 0.2s ease;
}

.post-status-card:hover {
  border-color: #22418d;
  opacity: 1;
}

.post-status-card--active {
  border-color: #22418d;
  background: rgba(34, 65, 141, 0.05);
}

.post-status-card--dim {
  opacity: 0.45;
}

.post-status-card__icon {
  font-size: 22px;
  color: #909399;
  margin-right: 10px;
}

.post-status-card__info {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
}

.post-status-card__count {
  font-size: 16px;
  font-weight: 700;
  color: #303133;
  font-variant-numeric: tabular-nums;
}

.post-status-card--active .post-status-card__count {
  color: #22418d;
}

.post-status-card__label {
  font-size: 12px;
  color: #909399;
  white-space: nowrap;
}

@media (max-width: 1650px) {
  .post-status-card {
    padding: 7px 12px;
    margin: 0 6px 6px 0;
  }

  .post-status-card__icon {
    font-size: 18px;
    margin-right: 8px;
  }

  .post-status-card__count {
    font-size: 14px;
  }

  .post-status-card__label {
    font-size: 11px;
  }

  .post-status-cluster--divided {
    padding-left: 12px;
    margin-left: 2px;
  }
}
</style>
